import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const StyledAppMenuItem = styled.li<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 40px;
  padding: 8px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease-in-out 0s;
  background-color: ${(props) =>
    props.$isSelected ? ThemePrisma.colors.green[4] + '!important' : 'none'};

  span:not(.icon) {
    color: ${(props) =>
      props.$isSelected ? ThemePrisma.colors.gray[1] : ThemePrisma.colors.gray[4]};
    width: 100%;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 0em;
    line-height: 1.5rem;
    font-weight: 400;
  }

  .icon,
  svg {
    width: 24px;
    height: 24px;
    color: ${(props) =>
      props.$isSelected
        ? ThemePrisma.colors.gray[1]
        : ThemePrisma.colors.gray[2]} !important;
    text-align: center;
  }

  &:hover {
    background: rgb(0 0 0 / 10%);
  }
`;

export const StyledAppSubMenuItem = styled.li<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  padding: 8px 8px 8px 40px;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out 0s;
  border-radius: 8px;
  cursor: pointer;

  span {
    color: ${(props) =>
      props.$isSelected ? ThemePrisma.colors.gray[1] : ThemePrisma.colors.gray[4]};
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 0em;
    line-height: 1.5rem;
    font-weight: ${(props) => (props.$isSelected ? 600 : 400)};
  }

  &:hover {
    background: rgb(0 0 0 / 10%);
  }
`;
